import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const LazyOAuthConsent = lazy(async () => await import('./oauth-consent'));

export const OAuthConsentRouter: RouteObject = {
  path: 'oauth/consent',
  element: <LazyOAuthConsent />
};
